export default function removeLocationHash() {
  if (process.browser) {
    window.location.hash = ''
    if ('pushState' in history) history.pushState(null, null, window.location.href.split('#')[0])
  }
}
